/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useQuery } from "@tanstack/react-query";
import Spinner from "../../components/Shared/Spinner";
import { StudentCourseProgress } from "../../api/Students/StudentCourseProgress";
import StudentProgressTable from "../../components/Dashboard/Students/StudentProgressTable";
import { useParams } from "react-router-dom";

const StudentProgress = () => {
  const { id } = useParams();
  const courseId = id || "";
  const { data: StudentsResponse, isLoading: isStudentsLoading } = useQuery({
    queryFn: () => StudentCourseProgress(courseId),
    queryKey: ["StudentProgress", courseId],
    staleTime: 0,
    refetchInterval: 0,
  });

  const students = StudentsResponse?.data || [];

  if (isStudentsLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div className="py-7">
      <h1 className="text-burntBlack font-bold text-[32px] mb-7">
        Students Progress
      </h1>
      <div className="p-8 rounded-xl bg-white border-black/15 shadow">
        {/* @ts-expect-error */}
        <StudentProgressTable data={students} />
      </div>
    </div>
  );
};

export default StudentProgress;
